// Available colors for todos
export const TODO_COLORS = [
  'rgb(223, 88, 165)',
  'rgb(245, 74, 69)',
  'rgb(255, 129, 26)',
  'rgb(53, 189, 75)',
  'rgb(51, 214, 192)',
  'rgb(51, 109, 244)',
  'rgb(62, 195, 247)',
  'rgb(71, 82, 230)',
  'rgb(122, 53, 240)',
  'rgb(191, 61, 191)',
  'rgb(143, 149, 158)'
]

// Get random color from the palette
export const getRandomColor = (): string => {
  return TODO_COLORS[Math.floor(Math.random() * TODO_COLORS.length)]
}

// Convert RGB to rgba with transparency
export const rgbToRgba = (rgb: string, alpha: number = 0.1): string => {
  return rgb.replace('rgb', 'rgba').replace(')', `, ${alpha})`)
}

// Get color RGB values as array
export const getRgbValues = (rgba: string): [number, number, number] => {
  const matches = rgba.match(/\d+/g)
  if (matches && matches.length >= 3) {
    return [parseInt(matches[0]), parseInt(matches[1]), parseInt(matches[2])]
  }
  return [0, 0, 0]
}

// Mix an RGB color with white background using alpha, return opaque rgb string
export const mixWithWhite = (rgb: string, alpha: number = 0.3): string => {
  const m = rgb.match(/\d+/g)
  if (!m || m.length < 3) return rgb
  const r = parseInt(m[0], 10)
  const g = parseInt(m[1], 10)
  const b = parseInt(m[2], 10)
  const mix = (c: number) => Math.round(c * alpha + 255 * (1 - alpha))
  const mr = mix(r)
  const mg = mix(g)
  const mb = mix(b)
  return `rgb(${mr}, ${mg}, ${mb})`
}